import Crud from '../components/Server/Crud'
import Entity from '../components/Server/Add'
import View from '../components/Server/View'
import Dashboard from '../components/Server/Dashboard'
import ServerDetails from '../components/Server/ServerDetails'
import AlertsPage from '../components/Server/AlertsPage'
// import Edit from '../components/Customer/Edit'

let routes = {
  path: '/Server',
  component: resolve => require(['../components/layout/App'], resolve),
  children: [{
      path: '/Servers',
      name: 'Listar Servidores',
      component: Crud,
      meta: {
        permission: 'is_admin'
      }
    },
    {
      path: '/',
      name: 'Dashboard de Monitoramento',
      component: Dashboard,
    },
    {
      path: '/servers/:id',
      name: 'Detalhes do Servidor',
      component: ServerDetails,
    },
    {
      path: '/server/alerts',
      name: 'Alertas do Sistema',
      component: AlertsPage,
    },
    {
      path: '/servers/Add',
      name: 'Novo Cadastro',
      component: Entity,
    },
    {
      path: '/servers/View/:id',
      name: 'Visualizar',
      component: View,
    },
    {
      path: '/servers/Edit/:id',
      name: 'Editar',
      component: Entity
    }
  ]
};

export default routes;
